import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
	selector: "app-card",
	templateUrl: "./card.component.html",
})
export class CardComponent implements OnInit {
	@Input() id: string;
	@Input() numero: string;
	@Input() priority: string = "Moyenne";
	@Input() userImage: string = "./assets/images/users/avatar.png";
	@Input() userName: string;
	@Input() title: string;
	@Input() link: string = "/tasks/details";
	@Input() date: string;
	@Input() subTitle: string;
	@Input() status: string;
	@Input() type: string;

	@Input() user: any;
	@Output() clickBtn = new EventEmitter();
	constructor() {}

	ngOnInit() {}
}
